<template>
  <main-layout>

    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar  screenIdParam="M-08-21"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t("label.router.pointInvalidationTop")}}</label>
        <sp-smart-button slot="cancel" @click="backPreviousPage">{{$t("button.common.data.cancel")}}</sp-smart-button>
        <narrow-down
          class="invalidationPoints-type"
          slot="create"
          :disabled= isDisabledButton
          @click="invalidSetUp"
          v-show="isshow">
          {{$t("button.common.invalidation")}}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">

      <!--  フォーム開始  -->
      <label slot="title" class="font-size-1" style="font-size: 20px;">{{this.tenantName}}</label>
      <div class="panel-search m-top-4">
        <div>
          <span class="point-type">
              <label class="fontSize">{{$t("label.point.common.pointType")}}</label>
          </span>
        </div>

        <el-radio-group v-model="walletType">

            <el-radio size="mini" label="1" id="workOfficePoint" @change="workOfficePoint">
              <span class="small-title">
                {{$t("label.point.common.workOfficePoint")}}
              </span>
            </el-radio>
            <el-radio size="mini" label="2" id="unDistributeUserPoint" @change="unDistributeUserPoint">
              <span class="small-title">
                {{$t("label.point.common.newUndistributedUserPoint")}}
              </span>
            </el-radio>
            <el-radio size="mini" label="3" id="userpoint" @change="userpoint">
              <span class="small-title">
                {{$t("label.point.common.userPoint")}}
              </span>
            </el-radio>

        </el-radio-group>
    </div>

    <!--   検索結果が表示 開始   -->
    <el-row>
      <el-row class="m-bottom-8"  v-if="walletType=='1'">
        <div id="search-result-workoffice-point">
          <company-wallet-work-office-point-search-result-beautify
            @on-invalid = "woPointInvalid"
            :result="result.pointList"/>
        </div>
      </el-row>

      <el-row class="m-bottom-8" v-if="walletType=='2'">
        <div id="search-result-unDistribute-user-point">
          <company-wallet-undistribute-user-point-search-result-beautify
            @on-invalid = "unDisPointInvalid"
            :result="result.pointList"/>
        </div>
      </el-row>

      <el-row class="m-bottom-8" v-if="walletType=='3'">
        <div id="search-result-user-point">
          <company-wallet-user-point-search-result-beautify
            ref ="userPointEdit"
            @on-edit ="handleEdit"
            :dateMonth ="this.dateMonth"
            :result="response"/>
        </div>
      </el-row>
    </el-row>
     <el-row class="form-group center-cancel">

        <sp-smart-button @click="backPreviousPage" class="smartBtn">{{$t("button.common.data.cancel")}}</sp-smart-button>

        <narrow-down
          class="invalidationPoints-type"
          @click="invalidSetUp"
          :disabled= isDisabledButton
          v-show="isshow">
          {{$t("button.common.invalidation")}}
        </narrow-down>

      </el-row>

      <point-invalid-popup
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        @on-isPassParam="isPassParam">
      </point-invalid-popup>

      <!-- userPoint编辑 UserPointInvalidEdit-->
      <user-point-invalid-edit-popup
        :userPointSearchFlg.sync="isShowPopup"
        :result="pointList"
        :holderName ="userHolderName"
        :walletId ="userWalletId"
        :isBack="isBack"
        @UserInvalidEditBack ="UserInvalidEditBack"
          >
      </user-point-invalid-edit-popup>

      <pointInvalidConfirmPopup
        :confirmPopupFlg.sync = "confirmPopupFlg"
        @comfirmPopup = "comfirmPopup"
      >
      </pointInvalidConfirmPopup>
      <loading-dialog :dialogVisible="loading" />
  </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi"
import NewDesignLayout from "@/layout/NewDesignLayout"
import Menubar from "@/components/leftmenu/Home"
import headTitle from "@/components/common/head/head"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import SpSmartButton from "@/components/common/sp-smart-button"
import errorCodeMsg from "@/utils/error-code-msg"
import CompanyWalletWorkOfficePointSearchResultBeautify from "@/components/system/CompanyWalletWorkOfficePointSearchResultBeautify"
import CompanyWalletUndistributeUserPointSearchResultBeautify from "@/components/system/CompanyWalletUndistributeUserPointSearchResultBeautify"
import CompanyWalletUserPointSearchResultBeautify from "@/components/system/CompanyWalletUserPointSearchResultBeautify"
import moment from 'moment'
import UserPointInvalidEditPopup from '@/components/system/popup/UserPointInvalidEditPopup.vue'
import PointInvalidPopup from '../../components/system/popup/PointInvalidPopup.vue'
import pointInvalidConfirmPopup from "@/components/system/popup/PointInvalidConfirmPopup"

export default {
  name: "InvalidationPointSearch",
  components: {
    LoadingDialog,
    MainLayout: NewDesignLayout,
    Menubar:Menubar,
    headTitle:headTitle,
    narrowDown: narrowDown,
    SpSmartButton,
    CompanyWalletWorkOfficePointSearchResultBeautify: CompanyWalletWorkOfficePointSearchResultBeautify,
    CompanyWalletUndistributeUserPointSearchResultBeautify: CompanyWalletUndistributeUserPointSearchResultBeautify,
    CompanyWalletUserPointSearchResultBeautify: CompanyWalletUserPointSearchResultBeautify,
    UserPointInvalidEditPopup: UserPointInvalidEditPopup,
    PointInvalidPopup: PointInvalidPopup,
    pointInvalidConfirmPopup,
  },
  data() {
    return {
      loading: null,
      isDisabledButton: true,
      isBack:"one",
      currentMonth: moment(new Date()).format("YYYY/MM"),
      walletType: '1',
      tenantName: null,
      tenantIds: [],
      acceptParm: null,
      tableLoadingAnim: null,
      isshow : true,
      centerDialogVisibleIsShow: false,
      confirmPopupFlg: false,
      userPointSearchShow: false,
      errorCodeMsg: false,
      isShowPopup:false,
      userEditResponse: null,
      //結果宣言に戻る
      walletId: null,
      userHolderName:"",
      userWalletId:"",
      pointList:[],
      result:{
        holderName: null,
        tenantId: [],
        pointList:[]
      },
      userPointShow:null,
      dateMonth:[],
      invalidReq:{
        query: {},
      },
      PointInvalidationBodyList: {
        query: [],
      },
      pointInvalidationList: [
        {
          yearMonth: null,
          invalidAmount: null,
        },
      ],
      response:[],
      workOfficePointIsShow: false,
      unDistributeUserPointIsShow: false,
      userPointIsShow: false,
    }
  },
  methods: {
    backPreviousPage(){
      let tenantName = this.$getPageInfo("point", "invalidation", "M-08-19", "tenantName")
      this.$savePageInfo("point", "invalidation", "M-08-21", "tenantName",tenantName)
      this.$savePageInfo("point", "invalidation", "M-08-21", "flag", true)
      this.$router.push("/point/invalidation/top")
    },
    UserInvalidEditBack(walletId,result){
      result.forEach(point =>{
        if(point.balance < point.invalidAmount){
          point.invalidAmount = point.balance
          point.balance = 0
        }else{
          point.balance = point.balance - point.invalidAmount
        }
        this.isDisabledButton = this.$refs.userPointEdit.setPointList(walletId,result)
      })
    },
    showTableLoadingAnim(id) {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: id,
          background: "#ebebe6"
        });
      }
    },
    //隠しフォームロードアニメーション
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    handleEdit(rowData){
      this.showTableLoadingAnim('search-result-user-point')
      this.holderId = []
      this.dateMonth = []
      this.holderId.push(rowData.holderId)
      SystemManageApi.getWalletBalanceDetail({
        holderId: this.holderId,
        walletType: this.walletType
      })
      .catch((error) => {
        this.hideTableLoadingAnim()
        errorCodeMsg(error, this)
      })
        .then(({ data }) => {
          this.userEditResponse = data.body;
          this.userHolderName = this.userEditResponse[0].holderName
          this.userWalletId = this.userEditResponse[0].walletId
          this.dateMonth.push(this.userEditResponse[0].pointList[0].endDate)
          this.dateMonth.push(this.userEditResponse[0].pointList[1].endDate)
          this.dateMonth.push(this.userEditResponse[0].pointList[2].endDate)
          this.dateMonth.push(this.userEditResponse[0].pointList[3].endDate)
          this.dateMonth.push(this.userEditResponse[0].pointList[4].endDate)
          this.dateMonth.push(this.userEditResponse[0].pointList[5].endDate)
          this.userEditResponse[0].pointList.forEach(point =>{
            point.invalidAmount = 0
          })
          this.pointList = this.userEditResponse[0].pointList

          this.isShowPopup = true;
        })
        .finally(() => {
          this.hideTableLoadingAnim()
        });
    },


    // workOfficePoint数据展示
    workOfficePoint:function(){
      this.showTableLoadingAnim('search-result-workoffice-point')
      this.isDisabledButton = true
      this.result.pointList = []
      this.showResult(this.walletType);
      this.unDistributeUserPointIsShow = false
      this.userPointIsShow = false
    },
    // 未配布userpoint数据展示
    unDistributeUserPoint:function(){
      this.showTableLoadingAnim('search-result-unDistribute-user-point')
      this.isDisabledButton = true
      this.result.pointList = []
      this.showResult(this.walletType);
      this.workOfficePointIsShow = false
      this.unDistributeUserPointIsShow = true
      this.userPointIsShow = false

    },
    // userpoint数据展示
    userpoint:function(){
      this.showTableLoadingAnim('search-result-user-point')
      this.isDisabledButton = true
      this.dateMonth = []
      SystemManageApi.getWalletBalanceDetail({
        walletType : this.walletType,
        HolderId : this.tenantIds
        })
        .catch((error) => {
          this.hideTableLoadingAnim()
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          //this.userPointShow = data.body;
          this.response = data.body
          this.dateMonth.push(this.response[0].pointList[0].endDate)
          this.dateMonth.push(this.response[0].pointList[1].endDate)
          this.dateMonth.push(this.response[0].pointList[2].endDate)
          this.dateMonth.push(this.response[0].pointList[3].endDate)
          this.dateMonth.push(this.response[0].pointList[4].endDate)
          this.dateMonth.push(this.response[0].pointList[5].endDate)
          this.response.forEach(wallet => {
            wallet.pointList.forEach(point => {
              point.invalidAmount = 0
            })
          })
        })
        .finally(() => {
          this.hideTableLoadingAnim()
        });
      this.workOfficePointIsShow = false
      this.unDistributeUserPointIsShow = false;
      this.userPointIsShow = true
    },
    isPassParam(param){
      if(param){
        this.donePointInvaild()
      }
    },
    comfirmPopup(){
      this.confirmPopupFlg = false
      if(this.walletType == "1"){
        this.workOfficePoint()
      }else if(this.walletType == "2"){
        this.unDistributeUserPoint()
      }else
        this.userpoint()
    },
    Addmonth(date,value){
        var str = date.split("");
        var year = parseInt(str[0] + str[1] + str[2] + str[3]);
        var month = parseInt(str[5] + str[6]);
        month = month + value;

        if(month > 12){
            month = month - 12;
            year = year +1;
        }
        return year + "年" + month + "月";
    },
    invalidSetUp(){
      // alert('失效设定')
      this.centerDialogVisibleIsShow = true
    },

    donePointInvaild(){
      this.loading = true
      this.centerDialogVisibleIsShow = false;
      this.invalidInfo();
      SystemManageApi.pointWalletDetailInvalidation(
        this.invalidReq.query
      )
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if(data.statusCode){
          this.loading = false
          this.centerDialogVisibleIsShow = false
          this.confirmPopupFlg = true
        }

      })
    },
    // 失效请求的参数整合
    invalidInfo(){
      if(this.walletType == 1 || this.walletType == 2){
        this.invalidReq.query = {};
        this.PointInvalidationBodyList = [];
        this.pointInvalidationList = [];
        let changeCount = null;
        for( let index of this.result.pointList) {
          if(this.walletType == 1){
            if(index.woPointChangeCount > index.WorkOfficeBalancePoint){
              index.woPointChangeCount = index.WorkOfficeBalancePoint
            }
            changeCount = index.woPointChangeCount
          }if(this.walletType == 2){
            if(index.undisUserPointChangeCount > index.unDistributeUserPoint){
              index.undisUserPointChangeCount = index.unDistributeUserPoint
            }
            changeCount = index.undisUserPointChangeCount
          }
          this.pointInvalidationList.push({
            yearMonth: index.yearMonth,
            invalidAmount: changeCount,
          })
        }
        this.PointInvalidationBodyList.push({
          walletId: this.walletId,
          pointInvalidationList: this.pointInvalidationList
        })
        this.invalidReq.query.walletType = this.walletType,
        this.invalidReq.query.PointInvalidationBodyList = this.PointInvalidationBodyList
      }
      else{
        this.invalidReq.query = {};
        this.invalidReq.query.walletType = "3"
        this.invalidReq.query.PointInvalidationBodyList = []
        let result = this.$refs.userPointEdit.getResult();
        result.forEach(data => {
          this.invalidReq.query.PointInvalidationBodyList.push({
              walletId: data.walletId,
              pointInvalidationList : data.pointList
          })
        })
      }
    },
    //cout联动
    woPointInvalid(yearMonth,count){
      this.isDisabledButton = true
      for(let i = 0 ; i < this.result.pointList.length ; i++)
      {
        if(this.result.pointList[i].yearMonth == yearMonth){
          this.result.pointList[i].woPointChangeCount = count
        }
        if(this.result.pointList[i].woPointChangeCount > 0 && this.result.pointList[i].WorkOfficeBalancePoint > 0){
          this.isDisabledButton = false
        }
      }
    },

    unDisPointInvalid(yearMonth,count){
      this.isDisabledButton = true
      for(let i = 0;i<this.result.pointList.length;i++){
        if(this.result.pointList[i].yearMonth == yearMonth){
          this.result.pointList[i].undisUserPointChangeCount = count
        }
        if(this.result.pointList[i].undisUserPointChangeCount > 0 && this.result.pointList[i].unDistributeUserPoint > 0){
          this.isDisabledButton = false
        }
      }
    },

    // 数据展示
    showResult(val){
      this.result.body = []
      this.dateMonth = []
      SystemManageApi.getWalletBalanceDetail({
        walletType : val,
        HolderId : this.tenantIds
        }
      )
      .catch((error) => {
        this.hideTableLoadingAnim()
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
          this.dateMonth.push(data.body[0].pointList[0].endDate)
          this.dateMonth.push(data.body[0].pointList[1].endDate)
          this.dateMonth.push(data.body[0].pointList[2].endDate)
          this.dateMonth.push(data.body[0].pointList[3].endDate)
          this.dateMonth.push(data.body[0].pointList[4].endDate)
          this.dateMonth.push(data.body[0].pointList[5].endDate)
          for(let body of data.body){
            this.walletId = body.walletId
            this.result.holderName = body.holderName
            this.result.holderId = body.holderId
            this.result.pointList = []
            if(body.pointList != null) {
              for (let point of body.pointList) {
                if(this.walletType == 1){
                  this.result.pointList.push({
                  yearMonth: point.yearMonth,
                  endDate: point.endDate,
                  startDate: point.startDate,
                  WorkOfficeBalancePoint: point.balance,
                  woPointChangeCount: 0,
                  })
                }if(this.walletType == 2){
                  this.result.pointList.push({
                  yearMonth: point.yearMonth,
                  endDate: point.endDate,
                  startDate: point.startDate,
                  unDistributeUserPoint: point.balance,
                  undisUserPointChangeCount: 0,
                  })
                }

              }
            }
          }
          if(this.result.length == 0){
          this.isshow = false
      }
      })
      .finally(() => {
        this.hideTableLoadingAnim()
      })
    },

  },
  created() {
        let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "",
        title: "label.router.pointManagement",
      },
      {
        path: "",
        title: "label.router.pointInvalidationTop",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

    this.acceptParm = this.$getPageInfo("point", "invalidation", "M-08-19", "editrouter")
    this.tenantName = this.acceptParm.tenantName
    this.tenantIds.push(this.acceptParm.tenantId)
    this.showResult('1');
  },

}
</script>

<style scoped lang="scss">
::v-deep .cancel-width{
  .my-button{
    height: 32px;
  }
}
.text-style-size-color {
  font-size: 16px;
  color:#525250;
}
::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  display: none;
}
::v-deep .el-table  .cell {
  color: #525250;
  font-size: 12px;
}
::v-deep .el-table th > .cell {
  color: #6B6B69;
}
::v-deep .radio-type {
  margin-left: 25px;
}
::v-deep .el-radio__input.is-checked + .el-radio__label{
  color: #525250;
  font-size: 14px;
}
.new_date_box {
  width: 190px;
  height: 40px;
}
.pick_date_box {
  width: 188px !important;
  height: 40px !important;
  border: none !important;
  background-color: #F2F2ED;
  float: left;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    font-size: 13px;
    border: none;
    height: 40px;
    border-radius: 4px !important;
    background-color: #F2F2ED;
    box-shadow: -2px -2px 5px #ffffff ,4px 5px 5px #E6E6E1 ;
  }
}
.new_date_box {
  ::v-deep.el-input--prefix {
    .el-input__inner {
      padding-left: 9px;
    }
  }
}
.float-left {
  float:left
}
.img-size {
  margin-left: -43px;
  position: absolute;
  margin-top: 10px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
::v-deep .el-icon-circle-close:before {
  display: none;
}

.title-div {
  width: 100%;
  height: 284px;
  background-color: #F7F7F2;
  border-radius: 8px;
}
::v-deep .el-form-item--small.el-form-item {
  margin-bottom:0px !important
}
.title-row {
  margin-left: 20px;
  padding-top: 30px;
}
.table-type {
  width: 100%;
}
::v-deep .el-form-item--small .el-form-item__error {
  width: 300px;
}
.point-type {
  width: 222px;
}

::v-deep .el-form-item__error {
  width: 300px !important;
}

::v-deep .link-primary:hover {
  color: rgba(50, 156, 166, 0.6) !important;
  cursor: pointer;
}

.font-size-13 {
  font-size: 13px;
}

::v-deep .cancel-width .my-button {
  width: 152px;
}

::v-deep .mediate-cancel .my-button{
  width: 152px;
  height: 32px;
  text-align: center;
}


::v-deep .my-button.is-disabled {
  opacity:0.3;
  background-color: #329CA6;
  color: #ffffff;
  font-size: 13px;
  box-shadow: -4px -4px 5px #ffffff,
     3px 3px 6px #B8B8AD !important;
}

.number-input ::v-deep .input_num_body .el-input .el-input__inner {
  background-color: transparent !important;
}

::v-deep .input_num_body {
  background-color: #F7F7F2 !important;
}

.bg-ivory-9::v-deep {
  .el-radio__inner {
    background-color: #f7f7f2 !important;
  }
}

.m-right-34 {
  margin-right: 34px;
}

.invalidationPoints-type-type ::v-deep{
  .my-button {
    width: 188px;
  }
}

::v-deep .create {
  padding-right: 24px;
}

.center-cancel {
  justify-content: center
}
.el-radio{
  margin-right: 98px;
  margin-top: 14px;
}
#unDistributeUserPoint{
  margin-right:123px;
}
.form-group center-cancel{
  width: 188px;
  height: 40px;
}
.smartBtn{
  margin-right: 10px;
}

.fontSize{
  color: #858582;
  font-size: 12px;
}
.small-title{
  font-size: 16px;
  color: #525250;
}
 .panel-search {
    margin-bottom: 60px !important;
}
</style>
